import {
  GoogleMap,
  InfoWindow,
  Marker,
  StreetViewPanorama,
} from '@react-google-maps/api';
import { useEffect, useState } from 'react';
import './App.css';
import PropTypes from 'prop-types';

const FindMap = ({ markerData, toggleShowList, isLoaded, showList }) => {
  const [mapRef, setMapRef] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isMarkerClicked, setIsMarkerClicked] = useState(false);
  const [infoWindowData, setInfoWindowData] = useState();
  const markers = markerData ? markerData : [];
  const [selectedMarker, setSelectedMarker] = useState({
    lat: markers[0]?.lat ? Number(markers[0]?.lat) : 0,
    lng: markers[0]?.lng ? Number(markers[0]?.lng) : 0,
  });
  const hasSelectedMarkerPosition =
    Number.isFinite(Number(selectedMarker?.lat)) &&
    Number.isFinite(Number(selectedMarker?.lng));

  const onMapLoad = (map) => {
    setMapRef(map);
    const bounds = new window.google.maps.LatLngBounds();
    markers?.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
    map.fitBounds(bounds);
  };

  const handleMarkerClick = (id, lat, lng, address, phone, name, ind) => {
    const nextLat = Number(lat);
    const nextLng = Number(lng);

    if (!Number.isFinite(nextLat) || !Number.isFinite(nextLng)) {
      return;
    }

    mapRef?.panTo({ lat: nextLat, lng: nextLng });
    setInfoWindowData({ id, address, phone, name });
    setIsOpen(true);
    toggleShowList(ind, id);
    setIsMarkerClicked(true);
    setSelectedMarker({
      lat: nextLat,
      lng: nextLng,
    });
  };

  useEffect(() => {
    if (Object.keys(showList).length > 0 && !isMarkerClicked) {
      const markerItem = markers[Object.keys(showList)[0]];
      if (!markerItem) {
        return;
      }

      let { id, lat, lng, address, phone, name } = markerItem;
      const nextLat = Number(lat);
      const nextLng = Number(lng);

      if (!Number.isFinite(nextLat) || !Number.isFinite(nextLng)) {
        return;
      }

      mapRef?.panTo({ lat: nextLat, lng: nextLng });
      setSelectedMarker({
        lat: nextLat,
        lng: nextLng,
      });
      setInfoWindowData({ id, address, phone, name });
      setIsOpen(true);
    } else {
      setIsMarkerClicked(false);
    }
  }, [showList]);

  useEffect(() => {
    setSelectedMarker({
      lat: markers[0]?.lat ? Number(markers[0]?.lat) : 0,
      lng: markers[0]?.lng ? Number(markers[0]?.lng) : 0,
    });
  }, [markers]);

  return (
    <div>
      {!isLoaded ? (
        <h3>Loading...</h3>
      ) : (
        <GoogleMap
          mapContainerClassName="map-select"
          onLoad={onMapLoad}
          onClick={() => setIsOpen(false)}
          options={{
            gestureHandling: 'greedy',
          }}
          zoom={1}
          center={selectedMarker}
        >
          {markers?.map(
            ({ address, lat, lng, phone, name, range_type_color, id }, ind) => (
              <Marker
                key={ind}
                position={{ lat, lng }}
                onClick={() => {
                  handleMarkerClick(id, lat, lng, address, phone, name, ind);
                }}
                icon={range_type_color}
              />
            )
          )}
          {isOpen && infoWindowData && hasSelectedMarkerPosition && (
            <InfoWindow
              position={{
                lat: Number(selectedMarker.lat),
                lng: Number(selectedMarker.lng),
              }}
              onCloseClick={() => {
                setIsOpen(false);
              }}
            >
              <div>
                <h3>{infoWindowData.name}</h3>
                <p>
                  {infoWindowData.address}
                  <br />
                  {infoWindowData.phone}
                </p>
              </div>
            </InfoWindow>
          )}
          <StreetViewPanorama />
        </GoogleMap>
      )}
    </div>
  );
};

FindMap.propTypes = {
  markerData: PropTypes.array,
  toggleShowList: PropTypes.func,
  isLoaded: PropTypes.bool,
  showList: PropTypes.object,
};

export default FindMap;
